import { useQuery } from "@grandvisionhq/graphql";
import { useStockIndicator } from "@grandvisionhq/inventory";
import GET_SHOPPING_LIST from "../../operations/queries/operations/queries/get-shopping-list.js";
import { mapShoppingListToWishlistItems } from "../../utils/utils/map-shopping-list-to-wishlist-items.js";
const useGetAnonWishlist = ({
  locale,
  isAuthLoading,
  isUserLoggedIn,
  localWishlist,
  clearWishlist
}) => {
  const { thresholds } = useStockIndicator();
  const anonWishlistQueryOptions = {
    context: { forwardHeaders: { "Accept-Language": locale } },
    skip: isAuthLoading || isUserLoggedIn || !localWishlist,
    variables: { shoppinglistId: localWishlist?.id || "" },
    onCompleted: (data) => {
      if (data.shoppinglistById.failure?.__typename === "ShoppinglistNotFoundFailure") {
        clearWishlist();
      }
    }
  };
  const {
    data: anonWishlistData,
    loading: isLoading,
    error,
    refetch
  } = useQuery(GET_SHOPPING_LIST, {
    ...anonWishlistQueryOptions
  });
  const mappedAnonData = anonWishlistData ? {
    items: mapShoppingListToWishlistItems(
      locale,
      anonWishlistData.shoppinglistById.shoppinglist,
      thresholds
    ),
    id: localWishlist?.id ?? ""
  } : null;
  return {
    data: !error ? mappedAnonData : null,
    loading: isLoading,
    error,
    refetch: async () => {
      await refetch();
    }
  };
};
export {
  useGetAnonWishlist
};
//# sourceMappingURL=use-get-anon-wishlist.js.map
